/**
 * Small helper that maps a curated list of lucide-react icon names (kebab-case,
 * matching what the backend stores on `db.service_categories.icon`) to the
 * actual React components. Used by both the admin editor and the public
 * /prices page so category icons stay consistent everywhere.
 */
import {
  HeartPulse, Zap, Sparkles, ClipboardCheck, Wifi, Activity, Users,
  Dumbbell, Timer, Stethoscope, Brain, Bike, Waves, Flame, HandHeart,
  Trophy, Baby,
} from "lucide-react";

export const CATEGORY_ICONS = {
  "heart-pulse":     HeartPulse,
  "zap":             Zap,
  "sparkles":        Sparkles,
  "clipboard-check": ClipboardCheck,
  "wifi":            Wifi,
  "activity":        Activity,
  "users":           Users,
  "dumbbell":        Dumbbell,
  "timer":           Timer,
  "stethoscope":     Stethoscope,
  "brain":           Brain,
  "bike":            Bike,
  "waves":           Waves,
  "flame":           Flame,
  "hand-heart":      HandHeart,
  "trophy":          Trophy,
  "baby":            Baby,
};

// Nice display labels for the admin dropdown.
export const CATEGORY_ICON_OPTIONS = Object.keys(CATEGORY_ICONS).map((k) => ({
  value: k,
  label: k.replace(/-/g, " "),
}));

export function CategoryIcon({ name, ...props }) {
  const Icon = CATEGORY_ICONS[name] || Sparkles;
  return <Icon {...props} />;
}
